export default __webpack_public_path__ + "static/logo-goel-99599bdbc307e63730dc4bd27a99f21e.png";